namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class SMTPPortEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "25", text: "25" });
            this.addItem({ id: "2525", text: "2525" });
            this.addItem({ id: "465", text: "465" });
            this.addItem({ id: "587", text: "587" });
        }
    }
}